const payloadHaveKeys = state => Object.keys( state.payload ).length;
const activeBar = state => state.bar.active;
const blockBar = state => state.bar.block;
const isInEditMode = ( state, getters ) => ( state.bar.active || getters.payloadHaveKeys ) && !state.bar.block && !state.bar.hide;
const helpers = state => state.helpers;
const payload = state => state.payload;

export default {
    payloadHaveKeys,
    activeBar,
    blockBar,
    isInEditMode,
    helpers,
    payload
};